<template>
  <div id="add-applicant">
    <el-form
      :model="isOta ? newFliggyOrder : newOrder"
      label-width="95px"
      ref="dataForm"
      :rules="rules"
    >
      <div v-if="!hideDate">
        <div class="top-subtitle" v-if="isOtaOnline">出行日期和申请人信息从飞猪订单获取，请核对申请人姓名开始办理</div>
        <!-- 出行时间标题 -->
        <div class="depart-date-title">
          <span class="title-txt">预计出行时间</span>
          <!-- <span class="earliest-depart-date-box">最早可出行时间：{{formatEarliestDepartDate}}</span> -->
        </div>

        <!-- 出行时间选择 -->
        <template v-if="isOta">
          <holiday-date-picker
            class="depart-date-select"
            :depart-date="newFliggyOrder.departDate"
            :holiday-date-arr="holidayArr"
            :min-disabled-date="disabledDate"
            :show-early="true"
            @input="onSelectDepartDate"
          ></holiday-date-picker>
        </template>
        <template v-else>
          <holiday-date-picker
            class="depart-date-select"
            :depart-date="newOrder.departDate"
            :holiday-date-arr="holidayArr"
            :min-disabled-date="disabledDate"
            :show-early="true"
            @input="onSelectDepartDate"
          ></holiday-date-picker>
        </template>

        <div
          class="depart-date-tips"
          v-if="showOtaDateTips && isOtaOnline"
        >飞猪订单填写的出行日期小于当前可选的出行日期，请手动选择</div>
        <!-- 分割线 -->
        <div class="hr" v-if="!normalOrUpload && !isOtaOnline"></div>
      </div>

      <!-- 手动添加申请人流程 -->
      <div v-if="!normalOrUpload && !isOtaOnline">
        <!-- 申请人和导入标题 -->
        <div class="applicant-and-import-title">
          <a
            @click="importOrderShow"
            class="import-applicant fr"
            v-if="!importOrder.open && !isOta"
          >
            <i class="el-icon-upload2"></i> 批量导入名单
          </a>

          <a
            class="new-applicant fr"
            :class="{'disable': ((isOta ? newFliggyOrder.applicant_set.length : newOrder.applicant.length) + isHaveApplicant) === maxItem}"
            v-if="!importOrder.open"
            @click="addApplicant"
          >
            <span>+</span> 新增出行人
          </a>

          <span class="title-txt">
            出行人信息
            <i
              class="applicant-count"
              v-if="!importOrder.open && !isOta"
            >（共{{newOrder.applicant.length}}人）</i>
            <i
              class="applicant-count"
              v-if="!importOrder.open && isOta"
            >({{newFliggyOrder.applicant_set.length}}/{{maxItem - isHaveApplicant}})</i>
          </span>
        </div>

        <!-- 增加申请人 -->
        <div
          class="add-applicant-box"
          v-if="!importOrder.open"
          :class="{ 'applicant-count-more-than-2': (isOta ? newFliggyOrder.applicant_set.length : newOrder.applicant.length) > 2 }"
        >
          <!-- 申请人列表 -->
          <div
            ref="applicantList"
            v-if="!isOta"
            class="applicant-list"
            :style="{ paddingRight: newOrder.applicant.length > 2 ? '20px' : '37px'}"
          >
            <template v-for="(applicant, index) in newOrder.applicant">
              <div
                class="applicant-item"
                :class="{ invalid: applicant.msg && submited}"
                :key="index"
              >
                <div class="left">
                  <el-form-item
                    label="姓名"
                    :class="{'has-error': submited && applicant.msg && applicant.msg.indexOf('身份') < 0 }"
                  >
                    <el-input
                      placeholder="输入姓名"
                      :value="applicant.applicant_name"
                      @change="changeApplicantName($event, index)"
                      :maxlength="40"
                      :minlength="2"
                      @focus="focusApplicantName"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    v-if="!isUniversalIdentity"
                    label="旅客身份"
                    :class="{'has-error': submited && applicant.msg && applicant.msg.indexOf('身份') > -1 }"
                  >
                    <el-select
                      :value="applicant.identity_id"
                      @input="changeApplicantIdentity($event, index)"
                      placeholder="选择身份"
                      popper-class="go-select"
                    >
                      <el-option
                        :label="identitys[identity]"
                        :value="identity"
                        v-for="(identity, idx) in getIdentitys(product, currentFlow)"
                        :key="'identity_' + idx"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>

                <div class="right" :class="{'universal': isUniversalIdentity}" v-if="newOrder.applicant.length > 1">
                  <img src="../../assets/imgs/delete.png" class="pointer" @click="delPerson(index)" />
                </div>
              </div>
              <div
                class="err-tips"
                v-if="submited && applicant.msg"
                :key="'err_' + index"
              >{{applicant.msg}}</div>
            </template>
            <div class="err-tips" v-if="isUniversalIdentity">该商品支持所有旅客身份</div>
          </div>

          <!-- 飞猪申请人列表 -->
          <div
            v-if="isOta"
            ref="applicantList"
            class="applicant-list"
            :style="{ paddingRight: newFliggyOrder.applicant_set.length > 2 ? '20px' : '37px'}"
          >
            <template v-for="(applicant, index) in newFliggyOrder.applicant_set">
              <div
                class="applicant-item"
                :class="{ invalid: fliggyApplicantMsg[index] && fliggyApplicantMsg[index][0] && submited}"
                :key="index"
              >
                <div class="left">
                  <div class="form-row">
                    <el-form-item
                      class="form-cell"
                      label="姓(中文)"
                      label-width="70px"
                      :class="{'has-error': (submited && fliggyApplicantMsg[index][1]) || (!submited && fliggyBlurMsg[index] && fliggyBlurMsg[index].indexOf('姓(中文)') > -1 )}"
                    >
                      <el-input
                        placeholder="输入中文姓"
                        :value="applicant.surname"
                        @change="changeOtaFormField('surname', $event, index)"
                        @blur="blurValidate('surname', $event.target.value, index)"
                        :minlength="2"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      class="form-cell"
                      label="名(中文)"
                      label-width="70px"
                      :class="{'has-error': submited && fliggyApplicantMsg[index][2] || (!submited && fliggyBlurMsg[index] && fliggyBlurMsg[index].indexOf('名(中文)') > -1 )}"
                    >
                      <el-input
                        placeholder="输入中文名"
                        :value="applicant.given_name"
                        @change="changeOtaFormField('given_name', $event, index)"
                        @blur="blurValidate('given_name', $event.target.value, index)"
                        :minlength="2"
                      ></el-input>
                    </el-form-item>
                  </div>

                  <div class="form-row">
                    <el-form-item
                      class="form-cell"
                      label="姓(拼音)"
                      label-width="70px"
                      :class="{'has-error': submited && fliggyApplicantMsg[index][3] || (!submited && fliggyBlurMsg[index] && fliggyBlurMsg[index].indexOf('姓(拼音)') > -1)}"
                    >
                      <el-input
                        placeholder="输入英文大写字母"
                        class="upper"
                        :value="applicant.surname_pinyin"
                        @change="changeOtaFormField('surname_pinyin', $event, index)"
                        @blur="blurValidate('surname_pinyin', $event.target.value, index)"
                        :minlength="2"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      class="form-cell"
                      label="名(拼音)"
                      label-width="70px"
                      :class="{'has-error': submited && fliggyApplicantMsg[index][4] || (!submited && fliggyBlurMsg[index] && fliggyBlurMsg[index].indexOf('名(拼音)') > -1)}"
                    >
                      <el-input
                        placeholder="输入英文大写字母"
                        class="upper"
                        :value="applicant.given_name_pinyin"
                        @change="changeOtaFormField('given_name_pinyin', $event, index)"
                        @blur="blurValidate('given_name_pinyin', $event.target.value, index)"
                        :minlength="2"
                      ></el-input>
                    </el-form-item>
                  </div>

                  <div class="form-row">
                    <el-form-item
                      class="form-cell"
                      label="护照号"
                      label-width="70px"
                      :class="{'has-error': submited && fliggyApplicantMsg[index][5] || (!submited && fliggyBlurMsg[index] && fliggyBlurMsg[index].indexOf('护照') > -1) }"
                    >
                      <el-input
                        placeholder="输入护照号"
                        class="upper"
                        :value="applicant.credential_no"
                        @change="changeOtaFormField('credential_no', $event, index)"
                        @blur="blurValidate('credential_no', $event.target.value, index)"
                        :maxlength="9"
                        :minlength="9"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="旅客身份"
                      class="form-cell"
                      label-width="70px"
                      :class="{'has-error': submited && fliggyApplicantMsg[index][6]}"
                    >
                      <el-select
                        v-if="!isUniversalIdentity"
                        :value="applicant.identity_id"
                        @input="changeOtaFormField('identity_id', $event, index)"
                        @blur="blurValidate('given_name_pinyin', $event.target.value, index)"
                        placeholder="选择身份"
                        popper-class="go-select"
                      >
                        <el-option
                          :label="identitys[identity]"
                          :value="identity"
                          v-for="(identity, idx) in getIdentitys(product, currentFlow)"
                          :key="'identity_' + idx"
                        ></el-option>
                      </el-select>
                      <el-select
                        v-if="isUniversalIdentity"
                        :value="applicant.identity_id"
                        @input="changeOtaFormField('identity_id', $event, index)"
                        @blur="blurValidate('given_name_pinyin', $event.target.value, index)"
                        placeholder="选择身份"
                        popper-class="go-select"
                      >
                        <el-option
                          label="通用身份"
                          :value="5"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>

                <div
                  class="right long-border"
                  v-if="newFliggyOrder.applicant_set.length > 1 && !isOtaOnline"
                >
                  <img src="../../assets/imgs/delete.png" class="pointer" @click="delPerson(index)" />
                </div>
              </div>

              <div
                class="err-tips"
                v-if="submited && fliggyApplicantMsg[index]"
                :key="'err_' + index"
              >{{fliggyApplicantMsg[index][0]}}</div>
              <div
                class="err-tips"
                v-if="!submited && fliggyBlurMsg[index]"
                :key="'blur_err_' + index"
              >{{fliggyBlurMsg[index]}}</div>
            </template>
          </div>
        </div>

        <!-- 导入申请人 -->
        <import-order
          v-if="importOrder.open"
          :product="product"
          :order="order"
          :currentFlow="currentFlow"
          @closeImport="closeImport"
        ></import-order>
      </div>

      <!-- 批量上传护照或身份证流程 -->
      <div id="batch-upload-flow" v-if="normalOrUpload">
        <div class="batch-upload-flow-content">
          <div class="title">
            <h4>申请人信息</h4>
            <span>（共{{filesArray.length}}人）</span>
          </div>
          <div class="batch-upload-flow-table">
            <div class="batch-upload-flow-table-head">
              <table>
                <thead>
                  <tr>
                    <th>{{productData.passportOrIDcard === 2 ? '护照' : '身份证'}}</th>
                    <th :class="{'universal': isUniversalIdentity}">姓名</th>
                    <th v-if="!isUniversalIdentity">旅客身份</th>
                    <th>状态</th>
                    <th></th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="batch-upload-flow-table-body">
              <table>
                <tbody>
                  <tr v-for="(file, index) in filesArray" :key="index">
                    <td class="ocrImg" @click="openImageReview(file.url)">
                      <div>
                        <img :src="file.url" />
                      </div>
                    </td>
                    <td class="ocrName">
                      <el-input
                        placeholder="请输入姓名"
                        :maxlength="40"
                        :minlength="2"
                        v-model="applicantName[index]"
                        :class="{'content-error': discernArray[index] && (!applicantName[index] || errorName[index]), 'universal-input': isUniversalIdentity}"
                        @blur="checkContent(index)"
                      ></el-input>
                    </td>
                    <td class="identity" v-if="!isUniversalIdentity">
                      <p class="universal" v-if="isUniversalIdentity">
                        通用身份
                      </p>
                      <el-select
                        v-if="!isUniversalIdentity"
                        v-model="identityID[index]"
                        placeholder="选择身份"
                        popper-class="go-select"
                        :class="{'content-error': discernArray[index] && identityID[index] === undefined }"
                      >
                        <el-option
                          :label="identitys[identity]"
                          :value="identity"
                          v-for="(identity, idx) in getBatchUploadIdentitys(productData)"
                          :key="'identity_' + idx"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="ocrStatus">
                      <div
                        :class="{'blue': status[index] === 2, 'red': status[index] === 1 }"
                        :style="{'background': '../../assets/imgs/group-visa/' + ['loading', 'fail-recognition', 'success-recognition'][status[index]] + '.gif)'}"
                      >{{ocrStatus[index]}}</div>
                    </td>
                    <td class="ocrDelete">
                      <img
                        src="../../assets/imgs/delete.png"
                        :class="{'pointer': !uploadDisabled, 'disabled': uploadDisabled}"
                        v-if="filesArray.length > 1"
                        @click="delBatchUploadPerson(index)"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="err-tips" v-if="isUniversalIdentity">该商品支持所有旅客身份</div>
      </div>
      <!-- 飞猪线上订单流程 -->
      <div id="batch-upload-flow" v-if="isOtaOnline">
        <div class="batch-upload-flow-content">
          <div class="title">
            <h4>申请人信息</h4>
            <span>（共{{otaOrderInfo.applicants.length}}人）</span>
          </div>
          <div class="batch-upload-flow-table">
            <div class="batch-upload-flow-table-head">
              <table>
                <thead>
                  <tr>
                    <th>护照</th>
                    <th>姓名</th>
                    <th>旅客身份</th>
                    <th>状态</th>
                    <th></th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="batch-upload-flow-table-body">
              <table>
                <tbody>
                  <tr v-for="(applicant, index) in otaOrderInfo.applicants" :key="index">
                    <td class="ocrImg" @click="openImageReview(applicant.passport.url)">
                      <div>
                        <img :src="applicant.passport.url" />
                      </div>
                    </td>
                    <td class="ocrName">
                      <el-input
                        placeholder="请输入姓名"
                        :maxlength="15"
                        :minlength="2"
                        v-model="applicantName[index]"
                        :class="{'content-error': discernArray[index] && (!applicantName[index] || errorName[index]) }"
                        @blur="checkContent(index)"
                      ></el-input>
                    </td>
                    <td class="identity">
                      <el-select
                        v-if="!isUniversalIdentity"
                        v-model="identityID[index]"
                        placeholder="选择身份"
                        popper-class="go-select"
                        :class="{'content-error': discernArray[index] && identityID[index] === undefined }"
                      >
                        <el-option
                          :label="identitys[identity]"
                          :value="identity"
                          v-for="(identity, idx) in getIdentitys(productData)"
                          :key="'identity_' + idx"
                        ></el-option>
                      </el-select>
                      <el-select
                        v-if="isUniversalIdentity"
                        v-model="identityID[index]"
                        placeholder="选择身份"
                        popper-class="go-select"
                        :class="{'content-error': discernArray[index] && identityID[index] === undefined }"
                      >
                        <el-option
                          label="通用身份"
                          :value="5"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="ocrStatus">
                      <div
                        :class="{'blue': status[index] === 2, 'red': status[index] === 1 }"
                        :style="{'background': '../../assets/imgs/group-visa/' + ['loading', 'fail-recognition', 'success-recognition'][status[index]] + '.gif)'}"
                      >{{ocrStatus[index]}}</div>
                    </td>
                    <td class="ocrDelete"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </el-form>

    <!-- 底部 -->
    <!-- 手动添加申请人流程 -->
    <div class="dialog-footer" v-if="!importOrder.open && !normalOrUpload">
      <el-button
        type="primary"
        @click="startAddOrder()"
        class="common-button"
        :class="{'mt-20': isOtaOnline}"
        :loading="submiting"
      >{{hideDate ? '确定' : '开始办理'}}</el-button>
    </div>

    <!-- 批量上传护照或身份证流程 -->
    <div class="batch-upload-flow-button" v-if="normalOrUpload">
      <input
        type="file"
        class="faraway batch-upload-input"
        accept="image/png, image/jpeg"
        multiple="multiple"
        ref="batchUploadFiles"
        @change="batchUpload"
      />
      <el-button
        class="continue-upload"
        @click="batchUploadSelect()"
        :disabled="uploadDisabled"
      >继续上传</el-button>
      <el-button
        type="primary"
        class="start-add-order"
        @click="startAddOrder()"
      >{{hideDate ? '确定' : '开始办理'}}</el-button>
    </div>

    <!-- 图片预览 -->
    <el-dialog
      id="ocr-review-box"
      title="图片预览"
      :show-close="true"
      :modal="false"
      v-model="imageReviewDialog.open"
    >
      <img :src="imageReviewDialog.src" />
    </el-dialog>
  </div>
</template>

<script>
import 'pinyin4js';
import { mapState, mapMutations } from 'vuex';
import {
  SELECT_NEW_ORDER_DEPART_DATE,
  ADD_NEW_ORDER_APPLICANT,
  DELETE_NEW_ORDER_APPLICANT,
  SET_APPLICANT_MSG,
  UPDATE_APPLICANT_NAME,
  UPDATE_APPLICANT_IDENTITY,
  UPDATE_NEW_FLIGGY_ORDER_APPLICANT_FIELD,
  SELECT_NEW_FLIGGY_ORDER_DEPART_DATE,
  SET_FLIGGY_APPLICANT_MSG,
  ADD_NEW_FLIGGY_ORDER_APPLICANT,
  DELETE_NEW_FLIGGY_ORDER_APPLICANT,
} from '../../store/modules/order/order-mutation-types';

import validates from '../../libs/validates';
import status from '../../libs/status';
import utils from '../../libs/utils';
import addNewOrderService from '../../services/add-new-order-service';

import holidayDatePicker from '../holiday-date-picker';
import importOrder from './import-order';
import Http from '../../libs/http';
import User from '../../libs/user';

export default {
  name: 'addApplicant',
  components: {
    holidayDatePicker,
    importOrder,
  },
  props: {
    countryId: {
      type: Number,
      required: true,
      default: 0,
    },
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    submiting: {
      type: Boolean,
      required: true,
      default: false,
    },
    normalOrUpload: {
      type: Boolean,
      default: false,
    },
    filesArray: {
      type: Array,
      default() {
        return [];
      },
    },
    ocrContentPromise: {
      type: Array,
      default() {
        return [];
      },
    },
    productData: {
      type: Object,
      default() {
        return {};
      },
    },
    order: {
      type: Object,
      default() {
        return {};
      },
    },
    currentFlow: {
      type: Number,
      default: 0,
    },
    hideDate: {
      type: Boolean,
      default: false,
    },
    modalClose: {
      type: Boolean,
      required: true,
      default: false,
    },
    earliestDepartDate: {
      type: String,
      required: true,
    },
    isOta: {
      type: Boolean,
      default: false,
    },
    maxItem: {
      type: Number,
      default: 200,
    },
    otaOrderInfo: {
      type: Object,
      default: null,
    },
    isImportModalShow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      rules: {
        // 表单验证
        depart_date: [validates.date('日期')],
      },
      holidays: [], // 国家放假日期
      disabledDate: '', // 最小禁止日期
      holidayArr: [], // 放假和休息数组
      importOrder: {
        // 导入
        open: false, // 打开导入
      },
      submited: false, // 提交
      identitys: status.identity, // 所有身份
      data: { applicant: [] },
      identityID: [],
      otaApplyId: [],
      applicantName: [],
      ocrContent: [],
      ocrStatus: [],
      status: [],
      imageReviewDialog: {
        open: false,
        src: '',
      },
      discernArray: [], // 用于存储 ocr 识别是否返回过结果
      errorName: [], // 申请人姓名是否有错误
      uploadDisabled: true, // 是否所有 ocr 都识别完成，用于控制能否继续上传
      fliggyBlurMsg: [], // 飞猪订单失去焦点的报错
      fliggyApplicantMsg: [], // 飞猪订单提交报错
      showOtaDateTips: false, // 飞猪线上订单出行日期提示控制
      isOtaOnline: false, // 是否是飞猪线上订单
    };
  },
  computed: {
    ...mapState('order/', ['newOrder', 'newFliggyOrder']),
    formatEarliestDepartDate() {
      // format 和 formatDate 到 add-prototype-methods中找，其实名称取得有点不合理
      return this.formatDate(this.earliestDepartDate);
    },
    isHaveApplicant: {
      get() {
        return this.order.applicant ? this.order.applicant.length : 0; // 订单内已有的申请人数量
      },
      set() {},
    },
    // 是否是通用商品
    isUniversalIdentity() {
      if (this.productData && this.productData.material && this.productData.material[0]) {
        return this.productData.material[0].identity_id === 5;
      }
      if (this.product && this.product.material && this.product.material[0]) {
        return this.product.material[0].identity_id === 5;
      }
      return false;

    },
  },
  watch: {
    // 外面选择的时候国家会变化
    countryId(newCountyId) {
      if (newCountyId && this.product && this.product.visa_product_id) {
        this.getHoliday(newCountyId);
      }
    },

    // 申请人变化的时候设置错误消息
    'newOrder.applicant': {
      deep: true,
      handler(newApplicants) {
        if (!newApplicants) return;
        newApplicants.forEach((applicant, index) => {
          const msg = addNewOrderService.getErrorMsg(applicant);
          this.SET_APPLICANT_MSG({ index, msg });
        });
      },
    },

    'newFliggyOrder.applicant_set': {
      deep: true,
      handler(newApplicants) {
        if (!newApplicants) return;
        newApplicants.forEach((applicant, index) => {
          const msg = addNewOrderService.getErrorMsg(applicant, true);
          // this.SET_FLIGGY_APPLICANT_MSG({ index, msg });
          this.fliggyApplicantMsg.splice(index, 1, msg);
          // this.fliggyApplicantMsg[index].splice(0, this.fliggyApplicantMsg[index].length, ...msg);
        });
      },
    },

    // 商品变了要重新加载放假日期
    product: {
      handler(newProduct) {
        if (!newProduct || !newProduct.visa_product_id) return;
        this.getHoliday();
      },
      deep: true,
    },

    earliestDepartDate(newVal) {
      if (newVal && this.countryId) {
        this.getHoliday();
      }
    },

    // 父窗口关闭的时候要做一些事情
    modalClose(newModalCloseStatus) {
      if (!newModalCloseStatus) {
        this.identityID = [];
        this.applicantName = [];
        this.fliggyBlurMsg = [];
        this.otaApplyId = [];

        this.submited = false;
        this.importOrder.open = false;
        this.$refs.dataForm.resetFields();
      }
    },

    ocrContentPromise: {
      handler(newValue) {
        if (newValue.length > 0) {
          this.ocrContentPromiseResult();
        }
      },
      // deep: true,
    },
    otaOrderInfo(newValue) {
      if (newValue && !newValue.ota_offline) {
        this.isOtaOnline = true;
        this.$nextTick(() => {
          this.initOtaOnlineOrder(newValue);
        });
      } else {
        this.isOtaOnline = false;
      }
    },

    // 监听父组件中是否关闭批量导入弹窗变量
    isImportModalShow(val) {
      this.importOrder.open = val;
    },
  },
  methods: {
    ...mapMutations('order/', [
      SELECT_NEW_ORDER_DEPART_DATE,
      ADD_NEW_ORDER_APPLICANT,
      DELETE_NEW_ORDER_APPLICANT,
      SET_APPLICANT_MSG,
      UPDATE_APPLICANT_NAME,
      UPDATE_APPLICANT_IDENTITY,
      UPDATE_NEW_FLIGGY_ORDER_APPLICANT_FIELD,
      SELECT_NEW_FLIGGY_ORDER_DEPART_DATE,
      SET_FLIGGY_APPLICANT_MSG,
      ADD_NEW_FLIGGY_ORDER_APPLICANT,
      DELETE_NEW_FLIGGY_ORDER_APPLICANT,
    ]),

    // 获取商品支持的身份
    getIdentitys: addNewOrderService.getIdentitys,

    // 获取批量上传资料可选的身份
    getBatchUploadIdentitys: addNewOrderService.getBatchUploadIdentitys,

    // 获取最早可出行日期
    getEarliestDepartDate() {
      return Http.post('/sys/visa_product_earliest_depart_date_query', {
        visa_product_id: this.product.visa_product_id,
        offline: 0,
      });
    },

    // 加载国家放假日历
    getHoliday(countyId) {
      addNewOrderService
        .getProductHolidays(countyId || this.countryId)
        .then((data) => {
          if (!Object.keys(data).length) return;
          this.holidays = data[Object.keys(data)[0]];
          this.disabledDate = addNewOrderService.handleDisabledDate(
            this.earliestDepartDate,
          );
          this.holidayArr = addNewOrderService.handleHolidayArr(
            this.holidays,
            this.disabledDate,
          );

          if (this.isOtaOnline) {
            // 如果订单出行时间晚于最早出行时间取订单出行时间;
            this.getEarliestDepartDate().then((res) => {
              this.earliestDepartDate = res.earliest_depart_date;
              if (
                addNewOrderService.compareDate(
                  this.earliestDepartDate,
                  this.otaOrderInfo.depart_date,
                ) === 1
              ) {
                this.showOtaDateTips = true;
              } else {
                const date = new Date(this.otaOrderInfo.depart_date);
                this.SELECT_NEW_FLIGGY_ORDER_DEPART_DATE({
                  date,
                });
                this.showOtaDateTips = false;
              }

              // 如果订单出行日期为 0000-00-00 代表飞猪订单没有出行日期，此时也不展示提示
              if (this.otaOrderInfo.depart_date === '0000-00-00') {
                this.showOtaDateTips = false;
              }
            });
          } else {
            this.showOtaDateTips = false;
          }
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },

    // 改变普通订单的表单值
    // 改变表单名字
    changeApplicantName(value, index) {
      this.UPDATE_APPLICANT_NAME({
        index,
        value,
      });
    },

    // 申请人姓名输入框获取焦点事件
    focusApplicantName() {
      // 工单埋点
      this.workOrderRecord();
    },
    // 工单埋点
    workOrderRecord() {
      // 销帮帮记录埋点
      if (User.isLogin()) {
        Http.post('/peer_behavior_record_add', {
          visa_product_id: this.product.visa_product_id, 
          behavior_type_id: 10003, // 10001:浏览商品列表页, 10002:浏览商详页, 10003:添加申请人, 10007:分享商详页, 10008:分享店铺
        });
      }
    },

    // 改变身份
    changeApplicantIdentity(identity, index) {
      this.UPDATE_APPLICANT_IDENTITY({
        index,
        identity,
      });
    },

    // 改变飞猪订单的表单值
    changeOtaFormField(field, value, index) {
      this.UPDATE_NEW_FLIGGY_ORDER_APPLICANT_FIELD({
        field,
        value,
        index,
      });
      const pinyinMap = {
        surname: 'surname_pinyin',
        given_name: 'given_name_pinyin',
      };
      // 如果是填写姓名，自动填写拼音
      if (pinyinMap[field]) {
        this.blurValidate(
          pinyinMap[field],
          PinyinHelper.convertToPinyinString(
            value,
            '',
            PinyinFormat.WITHOUT_TONE,
          ),
          index,
        );
      }
    },

    blurValidate(field, value, index) {
      value = value.toUpperCase();
      this.UPDATE_NEW_FLIGGY_ORDER_APPLICANT_FIELD({
        field,
        value,
        index,
      });
      const msg = addNewOrderService.getBlurErrorMsg(field, value);
      if (!this.fliggyBlurMsg[index]) {
        this.fliggyBlurMsg[index] = '';
      }
      this.fliggyBlurMsg.splice(index, 1, msg);
    },

    // 表单是否合法
    formValid() {
      this.submited = true;

      // 待上传资料页时没有日期不需要验证
      if (!this.hideDate && !this.newOrder.departDate) {
        utils.msg.error('请选择预计出行时间！');
        return false;
      }

      // 所有申请人的名字和身份都填写了
      const isAllApplicantNameAndIdentityFilled = this.newOrder.applicant.every(
        (ap) => {
          const isIdentityFilled =
            typeof ap.identity_id !== 'undefined' && ap.identity_id !== '';
          return Boolean(ap.applicant_name) && isIdentityFilled;
        },
      );

      if (!isAllApplicantNameAndIdentityFilled) {
        utils.msg.error('请将申请人信息填写完整');
        return false;
      }

      if (this.newOrder.applicant.some(ap => ap.msg)) {
        utils.msg.error('内容填写有误，请检查标红部分');
        return false;
      }

      return true;
    },

    // 飞猪表单校验
    fliggyFormValid() {
      this.submited = true;
      this.fliggyBlurMsg = [];

      // 待上传资料页时没有日期不需要验证
      if (!this.hideDate && !this.newFliggyOrder.departDate) {
        utils.msg.error('请选择预计出行时间！');
        return false;
      }

      // 所有申请人的名字和身份证都填写了
      const isAllFieldDone = this.newFliggyOrder.applicant_set.every((ap) => {
        const isIdentityFilled =
          typeof ap.identity_id !== 'undefined' && ap.identity_id !== '';
        return (
          !!ap.surname &&
          !!ap.given_name &&
          !!ap.surname_pinyin &&
          !!ap.given_name_pinyin &&
          !!ap.credential_no &&
          isIdentityFilled
        );
      });

      this.newFliggyOrder.applicant_set.forEach((item, index) => {
        this.fliggyApplicantMsg.splice(
          index,
          1,
          addNewOrderService.getErrorMsg(item, true),
        );
      });

      if (!isAllFieldDone) {
        utils.msg.error('请将申请人信息填写完整');
        return false;
      }

      if (this.fliggyApplicantMsg.some(msg => msg[0])) {
        utils.msg.error('内容填写有误，请检查标红部分');
        return false;
      }

      return true;
    },

    // 选择出行日期
    onSelectDepartDate(date) {
      if (this.isOta) {
        this.SELECT_NEW_FLIGGY_ORDER_DEPART_DATE({ date });
        this.showOtaDateTips = false;
      } else {
        this.SELECT_NEW_ORDER_DEPART_DATE({ date });
      }
    },

    // 增加申请人
    addApplicant() {
      // 订单内已有申请人数量
      this.isHaveApplicant = this.order.applicant
        ? this.order.applicant.length
        : 0;

      let identity_id;
      // 如果是通用身份商品，新增申请人直接将身份设置为通用身份
      if (this.isUniversalIdentity) {
        identity_id = 5;
      }

      // 飞猪和普通修改不同的state （newFliggyOrder 和 newOrder）
      if (this.isOta) {
        if (
          this.newFliggyOrder.applicant_set.length + this.isHaveApplicant <
          this.maxItem
        ) {
          // MtaH5.clickStat('newapplicant');
          this.ADD_NEW_FLIGGY_ORDER_APPLICANT({
            applicant_set: {
              surname: '',
              given_name: '',
              surname_pinyin: '',
              given_name_pinyin: '',
              credential_no: '',
              identity_id,
              msg: '',
            },
          });

          this.$nextTick(() => {
            this.$refs.applicantList.scrollTop = this.$refs.applicantList.scrollHeight;
          });

          this.submited = false;
        }
      } else {
        if (this.newOrder.applicant.length + this.isHaveApplicant < 200) {
          MtaH5.clickStat('newapplicant');
          this.ADD_NEW_ORDER_APPLICANT({
            applicant: {
              applicant_name: '',
              identity_id,
              msg: '',
            },
          });

          this.$nextTick(() => {
            this.$refs.applicantList.scrollTop = this.$refs.applicantList.scrollHeight;
          });

          this.submited = false;
        }
      }
    },

    // 删除申请人
    delPerson(index) {
      if (this.isOta) {
        this.DELETE_NEW_FLIGGY_ORDER_APPLICANT({ index });
        this.fliggyBlurMsg.splice(index, 1);
        this.fliggyApplicantMsg.splice(index, 1);
      } else {
        this.DELETE_NEW_ORDER_APPLICANT({ index });
      }
    },

    // 关闭导入
    closeImport() {
      this.importOrder.open = false;
    },
    // 打开批量导入弹窗并且增加埋点
    importOrderShow() {
      this.importOrder.open = true;
      this.$emit('importApplicantOpen');
      MtaH5.clickStat('importapplicant');
    },

    batchUploadSelect() {
      this.$el.querySelector('#add-applicant .batch-upload-input').click();
    },

    // 继续上传
    batchUpload(e) {
      // 需要先禁用“继续上传”按钮
      this.uploadDisabled = true;
      const files = e.target.files;

      // 先判断一次上传的文件数量
      if (files.length > 20) {
        this.$message.error('一次最多上传 20 张图片');
        this.uploadDisabled = false;
        return;
      }
      this.$emit('batchUpload', files, 2);

      // 清除文件，避免选择同一张图片时不触发 change 事件
      this.$refs.batchUploadFiles.value = null;
    },

    // 开始办理
    startAddOrder() {
      // 如果 ocrContent 没有内容，说明是手动添加申请人流程或线下添加流程
      if (this.ocrContent.length === 0) {
        // 表单验证
        if (!this.isOta && this.formValid()) {
          this.newOrder.applicant.forEach((el) => {
            this.identityID.push(el.identity_id);
            this.applicantName.push(el.applicant_name);
          });
          // 订单内已有申请人数量
          this.isHaveApplicant = this.order.applicant
            ? this.order.applicant.length
            : 0;
          this.$emit(
            'startAddOrder',
            this.identityID,
            this.applicantName,
            this.ocrContent,
            this.isHaveApplicant,
          );
        } else if (this.isOta && this.fliggyFormValid()) {
          this.newFliggyOrder.applicant_set.forEach((el) => {
            this.identityID.push(el.identity_id);
            this.applicantName.push(el.applicant_name);
          });
          // 订单内已有申请人数量
          this.isHaveApplicant = this.order.applicant
            ? this.order.applicant.length
            : 0;
          this.$emit(
            'startAddOrder',
            this.identityID,
            this.applicantName,
            this.ocrContent,
            this.isHaveApplicant,
          );
        }
      } else {
        // 订单内已有申请人数量
        this.isHaveApplicant = this.order.applicant
          ? this.order.applicant.length
          : 0;
        this.$emit(
          'startAddOrder',
          this.identityID,
          this.applicantName,
          this.ocrContent,
          this.isHaveApplicant,
          this.otaApplyId,
        );
      }
    },

    // ocr 资料状态
    ocrContentPromiseResult() {
      this.ocrContentPromise.forEach((el, index) => {
        // 只有没有返回过结果才需要处理
        if (!this.discernArray[index]) {
          const type =
            this.productData.passportOrIDcard === 2 ? '护照' : '身份证';
          this.ocrStatus[index] = `正在识别${type}信息`;
          this.status[index] = 0;

          el.then((data) => {
            // 因为传身份证国徽面也可以返回数据，需要单独处理一下
            if (!data.id_no && !data.fullname) {
              // 这个条件成立说明，识别的是身份证国徽面

              this.$set(this.ocrStatus, index, `${type}信息识别失败`);
              this.$set(this.applicantName, index, '');
              this.$set(this.status, index, 1);
              this.$set(this.discernArray, index, true);
              // 如果是通用身份，设置id为5
              if (this.isUniversalIdentity) {
                this.$set(this.identityID, index, 5);
              }
              this.ocrContent[index] = '信息识别不成功，请重新上传';
              return;
            }

            this.$set(this.ocrStatus, index, `${type}信息识别成功`);
            this.$set(this.applicantName, index, data.fullname);
            this.$set(this.status, index, 2);
            this.$set(this.discernArray, index, true);
            // 如果是通用身份，设置id为5
            if (this.isUniversalIdentity) {
              this.$set(this.identityID, index, 5);
            }
            this.ocrContent[index] = data;
          })
            .catch((error) => {
              this.$set(this.ocrStatus, index, `${type}信息识别失败`);
              this.$set(this.applicantName, index, '');
              // 如果是通用身份，设置id为5
              if (this.isUniversalIdentity) {
                this.$set(this.identityID, index, 5);
              }
              this.$set(this.status, index, 1);
              this.$set(this.discernArray, index, true);
              this.ocrContent[index] = error;
            })
            .finally(() => {
              // 获取到 ocr 信息后验证一下姓名（是否包含空格非中文字符等）
              this.checkContent(index);

              // 标记文件已经被上传识别
              this.$emit('fileUploaded', index);
            });
        }
      });

      // 所有 ocr 资料都识别完后，让“继续上传”按钮启用
      // 把状态为 reject 的 promise 的错误结果 catch 住
      Promise.all(
        this.ocrContentPromise.map(promiseItem => promiseItem.catch(err => err)),
      )
        .then(() => {
          this.uploadDisabled = false;
        })
        .catch((error) => {
          // 这里理论上不会到 catch 了，以防万一，即使 catch 了，也让“继续上传”按钮可以点击
          this.uploadDisabled = false;
          if (error) {
            console.log(error);
          }
        });
    },

    // 删除批量上传资料的联系人
    delBatchUploadPerson(index) {
      if (this.uploadDisabled) {
        return;
      }
      if (this.discernArray[index]) {
        this.filesArray.splice(index, 1);
        this.ocrContent.splice(index, 1);
        this.ocrContentPromise.splice(index, 1);

        this.ocrStatus.splice(index, 1);
        this.status.splice(index, 1);
        this.applicantName.splice(index, 1);
        this.identityID.splice(index, 1);
        this.discernArray.splice(index, 1);

        this.$emit('batchUploadApplicantDelete');
      }
    },

    // 飞猪线上订单设置好初始OCR信息
    initOtaOnlineOrder(data) {
      data.applicants.forEach((item, index) => {
        if (item.passport.fullname) {
          this.$set(this.ocrStatus, index, '护照信息识别成功');
          this.$set(this.applicantName, index, item.passport.fullname);
          this.$set(this.status, index, 2);
          this.$set(this.discernArray, index, true);
          this.$set(this.identityID, index, item.identity_id);
          this.$set(this.otaApplyId, index, item.ota_apply_id);
          this.ocrContent[index] = item.passport;
        } else {
          this.$set(this.ocrStatus, index, '护照信息识别失败');
          this.$set(this.applicantName, index, '');
          this.$set(this.status, index, 1);
          this.$set(this.discernArray, index, true);
          if (typeof item.identity_id !== 'undefined') {
            this.$set(this.identityID, index, item.identity_id);
          } else {
            this.$set(this.identityID, index, undefined);
          }
          this.$set(this.otaApplyId, index, item.ota_apply_id);
          this.ocrContent[index] = item.passport;
        }
      });
    },

    // 打开图片预览
    openImageReview(imageSrc) {
      this.imageReviewDialog.open = true;
      this.imageReviewDialog.src = imageSrc;
    },

    // 校验内容
    checkContent(index) {
      this.$set(this.errorName, index, false);
      if (this.applicantName[index]) {
        if (this.applicantName[index].length < 2) {
          // this.$message.error('申请人姓名过短');
          this.$message.error('请将申请人信息补充完整');
          this.$set(this.errorName, index, true);
        }
      }
    },
  },
  created() {
    this.fliggyApplicantMsg.push([]);
    if (this.otaOrderInfo && this.otaOrderInfo.ota_offline === 0) {
      this.isOtaOnline = true;
      this.initOtaOnlineOrder(this.otaOrderInfo);
    } else {
      this.isOtaOnline = false;
    }
  },
};
</script>

<style lang="less">
@import "../../assets/less/variable";

#add-applicant {
  padding-top: 20px;
  .top-subtitle {
    margin: -20px -50px 20px;
    height: 40px;
    text-align: center;
    background-color: fade(#5e9be1, 10);
    color: #5e9be1;
    font-size: 14px;
    line-height: 40px;
  }
  .title-txt {
    line-height: 1;
    font-size: 16px;
    font-weight: 500;
    color: #1f2d3d;
  }
  .depart-date-title {
    margin: 0 0 18px 0;
    display: flex;
    justify-content: space-between;
  }
  .depart-date-select {
    width: 580px;
  }
  .depart-date-tips {
    margin-top: 5px;
    line-height: 1;
    font-size: 12px;
    color: #ff5a60;
  }
  .hr {
    margin-top: 18px;
  }
  .applicant-and-import-title {
    margin: 24px 0;
    .import-applicant {
      color: @link;
      margin-left: 20px;
    }
    .applicant-count {
      color: @red;
      font-size: 13px;
    }
    .new-applicant {
      display: inline-block;
      border: 1px solid @main;
      border-radius: 3px;
      height: 28px;
      line-height: 26px;
      color: @main;
      font-size: 14px;
      text-align: center;
      width: 100px;
      vertical-align: middle;
      margin-top: -6px;
      &.disable {
        background-color: #fff;
        color: #cfcfcf;
        border: solid 1px #cfcfcf;
      }
      span {
        font-size: 16px;
      }
    }
  }
  .add-applicant-box {
    position: relative;
    &.applicant-count-more-than-2::after {
      position: absolute;
      content: "";
      display: block;
      left: 0;
      right: 0;
      bottom: 0;
      height: 20px;
      background-image: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0.3),
        white
      );
    }

    .applicant-list {
      max-height: 244px;
      overflow-y: auto;
      margin: 0 -37px;
      padding: 0 37px;
      padding-bottom: 22px;

      .el-select {
        display: block;
      }
    }

    .applicant-item {
      width: 100%;
      display: table;
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 0 0 0 15px;

      & + .applicant-item {
        margin-top: 14px;
      }

      &.invalid {
        border-color: @red;
      }

      .form-box {
        display: flex;
        flex-wrap: wrap;
      }

      .form-row {
        display: flex;
        width: 100%;
        .form-cell {
          width: 50%;
          border-top: none;
          border-bottom: 1px solid #e9e9e9;
          padding-right: 10px;
          .upper input {
            text-transform: uppercase;
          }
        }
        .form-cell + .form-cell {
          position: relative;
          padding-left: 10px;
          padding-right: 0;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 12px;
            width: 1px;
            height: 20px;
            border-radius: 50%;
            background-color: #f0f0f0;
          }
        }
      }

      .left {
        display: table-cell;
        padding-right: 15px;
      }

      .right {
        width: 60px;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
        position: relative;
        margin-left: 10px;

        &::before {
          content: "";
          display: block;
          border-left: 1px solid #e9e9e9;
          height: 50px;
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -25px;
        }

        &.universal::before {
          display: none;
        }

        &.long-border::before {
          height: 0;
        }
      }

      input,
      select {
        border: none;
        height: 43px;
      }

      .el-form-item__label {
        padding: 15px 12px 14px 0;
      }
    }

    // element-ui下拉框箭头样式
    .el-input__icon {
      color: #97989d;
    }

    .el-form-item {
      margin: 0;
    }

    .go-select {
      margin-top: -2px;
    }

    .el-form-item + .el-form-item {
      border-top: 1px solid #e9e9e9;
    }

    .err-tips {
      color: @red;
      margin: 5px 0 16px 15px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .el-date-editor i {
      display: none;
    }
  }
  .el-dialog__footer {
    padding: 25px 0 30px 0;
    margin: -30px 50px 0 50px;
  }

  .dialog-footer {
    text-align: center;
    .mt-20 {
      margin-top: 20px;
    }
    .el-button {
      width: 240px;
      height: 40px;
      line-height: 38px;
      font-size: 16px;
    }
  }

  #batch-upload-flow {
    padding: 30px 0 0 0;
    .batch-upload-flow-content {
      .title {
        display: flex;
        align-items: baseline;
        margin-bottom: 10px;
        h4 {
          font-size: 16px;
          color: #333333;
          font-weight: normal;
        }
        span {
          font-size: 14px;
          color: #ff5a60;
        }
      }
      .batch-upload-flow-table {
        border-radius: 1px;
        border: solid 1px #dddddd;
        width: 580px;
        box-sizing: border-box;
        .batch-upload-flow-table-head {
          table {
            width: 100%;
            background-color: #f2f9ff;
            thead {
              th {
                height: 38px;
                font-size: 12px;
                font-weight: normal;
                color: #6f6f6f;
              }
              th:nth-of-type(1) {
                width: 106px;
              }
              th:nth-of-type(2) {
                width: 120px;
              }
              th:nth-of-type(3) {
                width: 145px;
              }
              th:nth-of-type(4) {
                width: 138px;
              }
              th:nth-of-type(5) {
                width: 69px;
              }
              th.universal {
                width: 220px;
              }
            }
          }
        }
        .batch-upload-flow-table-body {
          max-height: 328px;
          overflow-x: hidden;
          overflow-y: auto;
          table {
            border-collapse: collapse;
            tbody {
              tr {
                border-bottom: 1px solid #f5f5f5;
              }
              .ocrImg {
                padding: 10px 20px;
                div {
                  width: 66px;
                  height: 46px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  img {
                    max-width: 100%;
                    max-height: 100%;
                  }
                }
              }
              .ocrName {
                padding: 20px 10px;
                input {
                  width: 100px;
                  height: 32px;
                  border-radius: 4px;
                  border: solid 1px #dddddd;
                }
                .universal-input {
                  input {
                    width: 200px;
                  }
                }
              }
              .identity {
                padding: 20px 10px;
                .universal {
                  width: 126px;
                  text-align: center;
                  white-space: nowrap;
                }
                input {
                  width: 120px;
                  height: 32px;
                  border-radius: 4px;
                  border: solid 1px #dddddd;
                  font-size: 14px;
                  color: #1f2d3d;
                }
              }
              .ocrStatus {
                padding: 30px 0;
                font-size: 12px;
                color: #333333;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 138px;
                div {
                  padding-left: 21px;
                  line-height: 16px;
                  background: url("../../assets/imgs/group-visa/loading.gif") 0
                    center no-repeat;
                  background-size: 16px 16px;
                }
                .blue {
                  color: #5e9be1;
                  background: url("../../assets/imgs/group-visa/success-recognition.gif")
                    0 center no-repeat;
                  background-size: 16px 16px;
                }
                .red {
                  color: #ff4646;
                  background: url("../../assets/imgs/group-visa/fail-recognition.gif")
                    0 center no-repeat;
                  background-size: 16px 16px;
                }
              }
              .ocrDelete {
                width: 100%;
                text-align: center;
              }
            }
          }
        }
      }

      .content-error {
        input {
          border: 1px solid #ff5a60 !important;
        }
      }

      .error-prompt {
        font-size: 12px;
        color: #ff5a60;
        line-height: 12px;
        display: inline-block;
        margin-top: 6px;
      }
    }
    .err-tips {
      margin-top: 8px;
      color: #ff5a60;
    }
  }
  .batch-upload-flow-button {
    display: flex;
    justify-content: space-between;
    margin: 20px 90px 10px 90px;
    button {
      width: 180px;
      height: 40px;
      border-radius: 4px;
      font-size: 14px;
    }
    .continue-upload.is-disabled {
      background: #eef1f6;
      border-color: #d1dbe5;
      color: #bfcbd9;
    }
  }

  #ocr-review-box {
    // 这里部分样式是为了覆盖 add-order.vue（或其它文件中） 中对 el-dialog 设置的样式
    .el-dialog {
      z-index: 3000 !important;
      position: absolute;
      left: 50%;
      top: 15% !important;
      width: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      background: #fff;
      border-radius: 2px;
    }
    .el-dialog__header {
      display: block;
    }
    .el-dialog__body {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 30px 20px;
      img {
        max-width: 100%;
      }
    }
  }
}

.disabled {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/add-order/add-applicant.vue